import { render, staticRenderFns } from "./SwimmingCompetition2.vue?vue&type=template&id=c5997288&"
import script from "./SwimmingCompetition2.vue?vue&type=script&lang=js&"
export * from "./SwimmingCompetition2.vue?vue&type=script&lang=js&"
import style0 from "./SwimmingCompetition2.vue?vue&type=style&index=0&id=c5997288&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports